import { SxProps, Theme } from "@mui/material";

export const PAGE_THREE_STYLES = {
  sectionTitle: {
    backgroundColor: "#63B4FF33",
    color: "#2979C3",
    borderRadius: "10px",
  } as SxProps<Theme>,
  label: {
    fontWeight: 400,
    marginLeft: "0",
    textAlign: "left" as const,
  } as SxProps<Theme>,
  textField: {
    width: "100%",
    maxWidth: "300px",
  } as SxProps<Theme>,
  select: {
    maxWidth: "300px",
    width: "100%",
  } as SxProps<Theme>,
  datePicker: {
    maxWidth: "300px",
    width: "100%",
  } as SxProps<Theme>,
  gridPadding: {
    paddingTop: "10px",
  } as SxProps<Theme>,
  gridItem: {
    padding: "0px",
  } as SxProps<Theme>,
  buttonGroup: {
    border: "1px solid #DBDBDB",
    borderRadius: "4px",
    padding: "20px",
  } as SxProps<Theme>,
  actionButton: {
    backgroundColor: "#63B4FF33",
    color: "#2979C3",
    border: "1px solid #2979C3",
    width: "100%",
    height: "30px",
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: "#2979C3",
      color: "#fff",
    },
  } as SxProps<Theme>,
};
